import React from "react";
import { motion, Variants } from "framer-motion";
import { useTranslation } from "react-i18next";
import Section from "../components/Section";
import cls from './SatbayevSpirit.module.css';

// Импортируем все 5 обложек
import tom1 from '../assets/1_tom.jpeg';
import tom2 from '../assets/2_tom.jpeg'; 
import tom3 from '../assets/3_tom.jpeg';
import tom4 from '../assets/4_tom.jpeg';
import tom5 from '../assets/5_tom.jpeg';

interface SatbayevSpiritProps {
  isActive: boolean;
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const textVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const bookVariants: Variants = {
  hidden: { opacity: 0, scale: 0.8, y: 30 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { type: "spring", stiffness: 100, damping: 12 },
  },
};

// Данные книг: картинка и ссылка на PDF
// Данные книг с ПРЯМЫМИ внешними ссылками
const booksData = [
  { 
    id: 1, 
    img: tom1, 
    link: "https://satbayev.university/upload/base/downloads/path/kitap/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/8701_1%20tom.pdf" 
  },
  { 
    id: 2, 
    img: tom2, 
    link: "https://satbayev.university/upload/base/downloads/path/kitap/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/8702_2%20tom.pdf" 
  },
  { 
    id: 3, 
    img: tom3, 
    link: "https://satbayev.university/upload/base/downloads/path/kitap/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/8703_3%20tom.pdf" 
  },
  { 
    id: 4, 
    img: tom4, 
    link: "https://satbayev.university/upload/base/downloads/path/kitap/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/8704_4%20tom_1-928.pdf" 
  },
  { 
    id: 5, 
    img: tom5, 
    link: "https://satbayev.university/upload/base/downloads/path/kitap/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/5%20%D1%82%D0%BE%D0%BC%D0%BD%D0%B8%D0%BA%20%D0%BF%D0%BE%D1%81%D0%BB%D0%B5%D0%B4%20%D0%B2%D0%B0%D1%80%D0%B8%D0%B0%D0%BD%D1%82%D1%8B/8705_5%20tom_1-832.pdf" 
  },
];

const SatbayevSpirit: React.FC<SatbayevSpiritProps> = ({ isActive }) => {
  const { t } = useTranslation();

  return (
    <Section isActive={isActive}>
      <div className={cls.spiritSection}>
        <motion.div 
          className={cls.container}
          variants={containerVariants}
          initial="hidden"
          animate={isActive ? "visible" : "hidden"}
        >
          <div className={cls.description}>
            <motion.p variants={textVariants}>{t('spirit.desc1')}</motion.p>
            <motion.p variants={textVariants}>{t('spirit.desc2')}</motion.p>
            <motion.p variants={textVariants}>{t('spirit.desc3')}</motion.p>
            <motion.p variants={textVariants}>{t('spirit.desc4')}</motion.p>
          </div>

          <motion.div className={cls.booksSection} variants={textVariants}>
            <h3 className={cls.bookTitle}>{t('spirit.bookTitle')}</h3>

            <div className={cls.booksBlock}>
              {booksData.map((book) => (
                <motion.div 
                  key={book.id} 
                  className={cls.bookItem}
                  variants={bookVariants}
                  whileHover={{ y: -5 }}
                >
                  <img className={cls.bookImg} src={book.img} alt={`${book.id} ${t('spirit.volume')}`} />
                  <a 
                    className={cls.bookBtn} 
                    href={book.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    {book.id} {t('spirit.volume')}
                  </a>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </Section>
  );
};

export default SatbayevSpirit;